module.exports = __webpack_public_path__ + "static/media/mesh-stack.c4a4195b.png";